import { AfterViewInit, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ValidationMessages } from '@app/@core/models';
import { untilComponentDestroyed, OnDestroyMixin } from '@w11k/ngx-componentdestroyed';
import { Subscription } from 'rxjs';
import { auditTime, distinctUntilChanged, tap } from 'rxjs/operators';

@Component({
    selector: 'ngx-validation-message',
    templateUrl: './validation-message.component.html',
    styleUrls: ['./validation-message.component.scss'],
    standalone: false
})
export class ValidationMessageComponent extends OnDestroyMixin implements OnChanges, OnDestroy, AfterViewInit {
  private statusSubscription: Subscription;

  @Input() group: UntypedFormGroup;
  @Input() controlName: string;
  @Input() validationMessages: ValidationMessages;

  constructor(private changeDetectorRef: ChangeDetectorRef) {
    super();
    this.changeDetectorRef.detach();
  }

  ngAfterViewInit(): void {
    this.changeDetectorRef.detectChanges();
  }

  ngOnChanges() {
    if (this.group && this.controlName) {
      if (this.statusSubscription) {
        this.statusSubscription.unsubscribe();
      }

      const control = this.group.get(this.controlName);
      this.statusSubscription = control.statusChanges
        .pipe(
          //distinctUntilChanged(),
          //auditTime(0),
          tap(() => this.changeDetectorRef.detectChanges()),
          untilComponentDestroyed(this)
        )
        .subscribe();
    }
  }

  ngOnDestroy() { super.ngOnDestroy(); }
}
